"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKInput = void 0;
var React = __importStar(require("react"));
var reactstrap_1 = require("reactstrap");
var common_1 = require("../../../common");
var GKFormGroup_1 = require("../GKFormGroup/GKFormGroup");
var GKInput = function (props) {
    // Destructure from myProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _a = (0, common_1.mapDefaultProps)(props, {
        _gkComponentName: "gk-input",
        className: props.minInline ? " form-control-min-inline" : undefined,
    }), minInline = _a.minInline, required = _a.required, myProps = __rest(_a, ["minInline", "required"]);
    var _b = React.useContext(GKFormGroup_1.GKFormGroupContext), setDisabled = _b.setDisabled, setValidation = _b.setValidation, setReadOnly = _b.setReadOnly, setRequired = _b.setRequired;
    React.useEffect(function () {
        setDisabled(props.disabled);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.disabled]);
    React.useEffect(function () {
        setValidation(props.invalid === true ? false : props.valid === true ? true : undefined);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.invalid, props.valid]);
    React.useEffect(function () {
        setReadOnly(props.readOnly);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.readOnly]);
    React.useEffect(function () {
        setRequired(required);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [required]);
    return React.createElement(reactstrap_1.Input, __assign({}, myProps));
};
exports.GKInput = GKInput;
